export function toCents(value) {
  const amount = String(value);
  if (!/^\d+(?:\.\d{1,2})?$/.test(amount)) return null;
  const [units, fraction = ''] = amount.split('.');
  const cents = Number(units) * 100 + Number(fraction.padEnd(2, '0'));
  return Number.isSafeInteger(cents) ? cents : null;
}

export function exactNumericAmount(cents) {
  if (!Number.isSafeInteger(cents) || cents < 0) return null;
  const amount = cents / 100;
  // The API requires a JSON number. Safe integer cents are the technical upper
  // bound, but some values below it still lose a cent when serialized.
  return toCents(JSON.stringify(amount)) === cents ? amount : null;
}
